function tokensForSlide(slide) {
  return (slide.dataset.filterIds || '')
    .split(/\s+/)
    .filter(Boolean);
}

function positionForSlide(slide, filterToken) {
  var prefix = filterToken + ':';
  var entry = (slide.dataset.filterPositions || '')
    .split(/\s+/)
    .find(function (value) { return value.indexOf(prefix) === 0; });
  var position = entry && Number(entry.slice(prefix.length));

  return Number.isFinite(position) ? position : Infinity;
}

function filterSlides(slides, filterToken) {
  if (!filterToken) return [];

  return Array.from(slides)
    .map(function (slide, index) {
      return { slide: slide, index: index, position: positionForSlide(slide, filterToken) };
    })
    .filter(function (item) {
      return tokensForSlide(item.slide).includes(filterToken);
    })
    .sort(function (left, right) {
      return (left.position - right.position) || (left.index - right.index);
    })
    .map(function (item) { return item.slide; });
}

function firstFilterToken(items) {
  var firstItem = Array.from(items).find(function (item) {
    return item.dataset.filter;
  });

  return firstItem ? firstItem.dataset.filter : null;
}

module.exports = {
  filterSlides: filterSlides,
  firstFilterToken: firstFilterToken,
};
